// extracted by css-extract-rspack-plugin
export default {"body":"InstructionsAlert_body__viWEu","divider":"InstructionsAlert_divider__+V4Dz","text":"InstructionsAlert_text__gLXXi"};